// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__152lM","left":"StickyBox_left__M4v0d","right":"StickyBox_right__1M-Cl"};